module.exports = __webpack_public_path__ + "img/21.6b102b2e.webp";